import { render, staticRenderFns } from "./contact.svg?vue&type=template&id=f5dbcfb0"
var script = {}


/* normalize component */
import normalizer from "!../../../../../ridget/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports